import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMFANeeded from './useMFANeeded';
import getToken from '../redux/selectors/getToken';

const useIsLoggedIn = () => {
  const token = useSelector(getToken());
  const mfaNeeded = useMFANeeded();
  return useMemo(() => !!token && !mfaNeeded, [token, mfaNeeded]);
};

export default useIsLoggedIn;
